export class LoadingLine {
  static _instance = null;
  constructor() {
    if (LoadingLine._instance) {
      throw new Error("Error: Usá LoadingLine.getInstace() para obtener el singleton.");
    }
    this.dom = document.getElementById('loading-line');
  }

  static getInstance() {
    if (!LoadingLine._instance) {
      LoadingLine._instance = new LoadingLine();
    }
    return LoadingLine._instance;
  }

  show() {
    this.dom?.classList.add('active');
  }

  hide() {
    this.dom?.classList.remove('active');
  }

}
